import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 12px;\n  line-height: 1;\n\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n'], ['\n  text-align: center;\n  font-size: 12px;\n  line-height: 1;\n\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n']);

import React from 'react';
import styled from 'styled-components';

var StyledFinePrint = styled.p(_templateObject, function (props) {
  return props.theme.dormifyBlack;
});

var _ref = React.createElement(
  StyledFinePrint,
  null,
  'By submitting this form, you agree to receive recurring automated promotional and personalized marketing text/email messages (e.g. cart reminders) from Dormify at the cell number or email address used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. View',
  ' ',
  React.createElement(
    'a',
    {
      href: 'http://attn.tv/dormify/terms.html',
      target: '_blank',
      rel: 'noopener noreferrer'
    },
    'Terms'
  ),
  ' ',
  '&',
  ' ',
  React.createElement(
    'a',
    {
      href: 'https://www.dormify.com/pages/privacy-policy',
      target: '_blank',
      rel: 'noopener noreferrer'
    },
    'Privacy'
  )
);

var FinePrintMessage = function FinePrintMessage() {
  return _ref;
};

export default FinePrintMessage;